import PropTypes from 'prop-types';
import React from 'react';
import {
  Form,
  Header,
  Select,
  Button,
  Icon,
  Checkbox,
} from 'semantic-ui-react';
import { OFFERS_INITIATED_SINCE } from '../../constants';

const Filter = ({
  offersInitiatedSince,
  onSelectHandler,
  submitFilter,
  singleDealerQuotes,
  groupQuotes,
  onCheckboxHandler,
  myQuotes,
  allStaffs,
}) => {
  const onChangeHandler = field => (event, data) => {
    event.preventDefault();
    onSelectHandler(field, data.value);
  };

  const onCheckboxChangeHandler = field => (event, data) => {
    event.preventDefault();
    onCheckboxHandler(field, data.checked);
  };

  return (
    <div>
      <Form>
        <Header size='small' color='blue' />
        <Form.Group widths='1'>
          <Form.Field>
            <Checkbox
              label='Single Dealer Quotes'
              checked={singleDealerQuotes}
              onChange={onCheckboxChangeHandler('singleDealerQuotes')}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label='My Quotes'
              checked={myQuotes}
              onChange={onCheckboxChangeHandler('myQuotes')}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label='Group Quotes'
              checked={groupQuotes}
              onChange={onCheckboxChangeHandler('groupQuotes')}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label='All DS Staff & Sales Reps'
              checked={allStaffs}
              onChange={onCheckboxChangeHandler('allStaffs')}
            />
          </Form.Field>
          <Form.Field>
            <label className='offer_since_label' htmlFor='offersInitiatedSince'>Offers initiated since</label>
          </Form.Field>
          <Form.Field>
            <Select
              id='offersInitiatedSince'
              placeholder='Offers initiated since'
              options={OFFERS_INITIATED_SINCE}
              onChange={onChangeHandler('offersInitiatedSince')}
              value={offersInitiatedSince}
              style={{ marginTop: '-10px', marginLeft: '-10px' }}
            />
          </Form.Field>
          <Form.Field>
            <Button
              color='green'
              onClick={submitFilter}
              inverted
              style={{ marginTop: '-10px' }}
            >
              <Icon name='checkmark' /> Apply
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
    </div>
  );
};

Filter.propTypes = {
  offersInitiatedSince: PropTypes.string,
  onSelectHandler: PropTypes.func.isRequired,
  submitFilter: PropTypes.func.isRequired,
  singleDealerQuotes: PropTypes.bool,
  groupQuotes: PropTypes.bool,
  onCheckboxHandler: PropTypes.func.isRequired,
  myQuotes: PropTypes.bool,
  allStaffs: PropTypes.bool,
};

export default Filter;
